import type * as Types from '../../../__generated__/bffGlobalTypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetMarketOptionsVariables = Types.Exact<{
  identifier: string;
}>;


export type GetMarketOptions = {
  signupPartnerBranches: Array<{
    regionIdentifier: string,
    marketDisplayName: string,
    marketActive: boolean
  }>
};


export const GetMarketOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMarketOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signupPartnerBranches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"identifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"identifier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regionIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"marketDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"marketActive"}}]}}]}}]} as unknown as DocumentNode<GetMarketOptions, GetMarketOptionsVariables>;